import {
  PaymentsAction,
  PaymentsActionTypes,
  PaymentsState,
} from './payments.types';

const initialState: PaymentsState = {
  currentPlanLoading: false,
  currentPlanError: null,
  currentPlan: null,
  paymentUsageLoading: false,
  paymentUsageError: null,
  paymentUsage: null,
  createPaymentLoading: false,
  createPaymentError: null,
  createPaymentMessage: null,
  createPaymentChangeType: null,
  cancelSubscriptionLoading: false,
  cancelSubscriptionError: null,
  customerPortalLoading: false,
  customerPortalError: null,
  checkoutUrl: null,
  selectedProduct: null,
  status: null,
};

const paymentsReducer = (
  state: PaymentsState = initialState,
  action: PaymentsAction
): PaymentsState => {
  switch (action.type) {
    case PaymentsActionTypes.CREATE_PAYMENT_REQUEST:
      return {
        ...state,
        createPaymentLoading: true,
        createPaymentError: null,
        createPaymentMessage: null,
        createPaymentChangeType: null,
        checkoutUrl: null,
        selectedProduct: action.payload.product,
      };

    case PaymentsActionTypes.CREATE_PAYMENT_SUCCESS:
      return {
        ...state,
        createPaymentLoading: false,
        createPaymentError: null,
        checkoutUrl: action.payload.checkoutUrl || null,
        createPaymentMessage: action.payload.message || null,
        createPaymentChangeType: action.payload.changeType || null,
      };

    case PaymentsActionTypes.CREATE_PAYMENT_FAILURE:
      return {
        ...state,
        createPaymentLoading: false,
        createPaymentError: action.payload,
      };

    case PaymentsActionTypes.GET_CURRENT_PLAN_REQUEST:
      return {
        ...state,
        currentPlanLoading: true,
        currentPlanError: null,
      };

    case PaymentsActionTypes.GET_CURRENT_PLAN_SUCCESS:
      return {
        ...state,
        currentPlanLoading: false,
        currentPlanError: null,
        currentPlan: action.payload,
      };

    case PaymentsActionTypes.GET_CURRENT_PLAN_FAILURE:
      return {
        ...state,
        currentPlanLoading: false,
        currentPlanError: action.payload,
        currentPlan: null,
      };

    case PaymentsActionTypes.GET_PAYMENT_USAGE_REQUEST:
      return {
        ...state,
        paymentUsageLoading: true,
        paymentUsageError: null,
      };

    case PaymentsActionTypes.GET_PAYMENT_USAGE_SUCCESS:
      return {
        ...state,
        paymentUsageLoading: false,
        paymentUsageError: null,
        paymentUsage: action.payload,
      };

    case PaymentsActionTypes.GET_PAYMENT_USAGE_FAILURE:
      return {
        ...state,
        paymentUsageLoading: false,
        paymentUsageError: action.payload,
      };

    case PaymentsActionTypes.CANCEL_SUBSCRIPTION_REQUEST:
      return {
        ...state,
        cancelSubscriptionLoading: true,
        cancelSubscriptionError: null,
      };

    case PaymentsActionTypes.CANCEL_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        cancelSubscriptionLoading: false,
        cancelSubscriptionError: null,
        status: action.payload.status,
      };

    case PaymentsActionTypes.CANCEL_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        cancelSubscriptionLoading: false,
        cancelSubscriptionError: action.payload,
      };

    case PaymentsActionTypes.CUSTOMER_PORTAL_REQUEST:
      return {
        ...state,
        customerPortalLoading: true,
        customerPortalError: null,
        checkoutUrl: null,
      };

    case PaymentsActionTypes.CUSTOMER_PORTAL_SUCCESS:
      return {
        ...state,
        customerPortalLoading: false,
        customerPortalError: null,
        checkoutUrl: action.payload.checkoutUrl,
      };

    case PaymentsActionTypes.CUSTOMER_PORTAL_FAILURE:
      return {
        ...state,
        customerPortalLoading: false,
        customerPortalError: action.payload,
      };

    case PaymentsActionTypes.CLEAR_PAYMENT_STATE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default paymentsReducer;
